<section class="bg-gradient-to-r from-blue-900 to-indigo-900 text-white py-24">

  <div class="w-11/12 mx-auto">

    <h2 class="text-4xl font-light mb-14">
      CIC GCC Charter
    </h2>

    <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-10">

      <div class="bg-white/10 p-8 rounded-xl">
        <h3 class="text-xl font-semibold mb-3">Build</h3>
        <p class="opacity-90">
          Implement new enterprise initiatives and develop
          digital platforms and enhancements.
        </p>
      </div>

      <div class="bg-white/10 p-8 rounded-xl">
        <h3 class="text-xl font-semibold mb-3">Run</h3>
        <p class="opacity-90">
          Provide application management services, reliability
          engineering, and operational support.
        </p>
      </div>

      <div class="bg-white/10 p-8 rounded-xl">
        <h3 class="text-xl font-semibold mb-3">Modernize</h3>
        <p class="opacity-90">
          Continuously improve enterprise platforms through
          automation and modernization initiatives.
        </p>
      </div>

      <div class="bg-white/10 p-8 rounded-xl">
        <h3 class="text-xl font-semibold mb-3">Integrate</h3>
        <p class="opacity-90">
          Integrate SAP platforms with enterprise applications,
          APIs, and data services.
        </p>
      </div>

    </div>

  </div>

</section>